export default "__VITE_ASSET__c5maR3PE__"